document.addEventListener('DOMContentLoaded', function (e) {
    const arrangemangModal = document.getElementById('arrangemangRegisterModal');
    if (!arrangemangModal) {
        return;
    }

    document.getElementById('reg-email')?.addEventListener('blur', function (e) {
        //validate email
        var email = e.target.value;
        var emailError = document.getElementById('reg-email-error');
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(email)) {
            e.target.classList.add('invalid');
            e.target.classList.remove('success');
            emailError.innerHTML = 'Ange en giltig epostadress';
            emailError.classList.remove('hidden');
        } else {
            e.target.classList.remove('invalid');
            e.target.classList.add('success');
            emailError.innerHTML = '';
            emailError.classList.add('hidden');
        }
    });
    document.getElementById('reg-full-name')?.addEventListener('blur', function (e) {
        //validate full name
        var fullName = e.target.value;
        var fullNameError = document.getElementById('reg-full-name-error');
        if (fullName.length < 2) {
            e.target.classList.add('invalid');
            e.target.classList.remove('success');
            fullNameError.innerHTML = 'Ange minst två bokstäver';
            fullNameError.classList.remove('hidden');
        } else {
            e.target.classList.remove('invalid');
            e.target.classList.add('success');
            fullNameError.innerHTML = '';
            fullNameError.classList.add('hidden');
        }
    });
    document.getElementById('personalnumber')?.addEventListener('blur', function (e) {
        //validate personal number with 12 digits and without any separator
        var personalNumber = e.target.value;
        var personalNumberError = document.getElementById('personalnumber-error');
        var re = /^\d{12}$/;
        if (personalNumber !== "" && !re.test(personalNumber)) {
            e.target.classList.add('invalid');
            e.target.classList.remove('success');
            personalNumberError.innerHTML = 'Ange personnummer med 12 siffror utan mellanrum eller bindestreck';
            personalNumberError.classList.remove('hidden');
        } else {
            e.target.classList.remove('invalid');
            e.target.classList.add('success');
            personalNumberError.innerHTML = '';
            personalNumberError.classList.add('hidden');
        }

    });
    document.getElementById("reg-phone")?.addEventListener('blur', function (e) {
        //validate phone number with only numbers and +, - or spaces
        var phoneNumber = e.target.value;
        var phoneNumberError = document.getElementById('reg-phone-error');
        //regex to allow swedish and international phone numbers with +, but not -
        var re = /^(\+?\d{1,3}[- ]?)?\d{6,14}$/;
        if (phoneNumber !== "" && !re.test(phoneNumber)) {
            e.target.classList.add('invalid');
            phoneNumberError.innerHTML = 'Ange ett giltigt telefonnummer';
            phoneNumberError.classList.remove('hidden');
        } else {
            e.target.classList.remove('invalid');
            e.target.classList.add('success');
            phoneNumberError.innerHTML = '';
            phoneNumberError.classList.add('hidden');
        }
    });
    document.querySelector('#arrangemangRegisterModal form').addEventListener('submit', function (e) {
        e.preventDefault();
        const form = e.target;
        if (document.querySelectorAll("input.invalid").length > 0) {
        return false;
        }

        const submitbuttons = form.querySelectorAll('input[type="submit"]');
        submitbuttons.forEach((btn) => {
            btn.setAttribute('disabled', '');
            btn.classList.add('disabled');
        });

        //@ts-ignore
        var eventId = document.getElementById('activity').value;
        //@ts-ignore
        var email = document.getElementById('reg-email')?.value;
        //@ts-ignore
        var fullName = document.getElementById('reg-full-name')?.value;
        //@ts-ignore
        var personNumber = document.getElementById('personalnumber')?.value;
        //@ts-ignore
        var mobilePhone = document.getElementById('reg-phone')?.value;
        //@ts-ignore
        var comment = document.getElementById('reg-userinputinfo').value;

        if (email !== "" && fullName !== "") {
            var valObj = {};
            valObj["ActivityId"] = eventId;
            valObj["FullName"] = fullName;
            valObj["Email"] = email;
            valObj["Phone"] = mobilePhone;
            valObj["PersonalIdentityNumber"] = personNumber;
            valObj["Comment"] = comment;

            //@ts-ignore
            $.ajax({
                type: 'POST',
                dataType: 'text',
                url: '/ArrangemangPage/RegisterUserOnArrangemang',
                data: valObj,
                success: function (data) {
                    data = JSON.parse(data);
                    if (data.success) {
                        window.location.href = window.location.origin + data.url;
                    } else {
                        if (data.field) {
                            const pnrErrField = document.getElementById('personalnumber-error');
                            pnrErrField.textContent = data.message;
                            pnrErrField.classList.remove('hidden');
                            document.getElementById('personalnumber').classList.add('invalid');
                        } else {
                            document.getElementById("submition-update").textContent = data.message;
                            document.querySelector(".register-response").classList.add("registration-error");
                            document.querySelector(".register-response").classList.remove("hidden");

                        }
                        document.getElementById("submit-form-register").classList.remove("disabled");
                        document.getElementById("register-arrangemang").removeAttribute("data-submitting");
                        submitbuttons.forEach((btn) => {
                            btn.removeAttribute('disabled');
                            btn.classList.remove('disabled');
                        });
                    }
                }
            });
        }
    });
});